import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <Button asChild variant="ghost" className="mb-4"><Link to="/"><ChevronLeft className="h-4 w-4 mr-1" />Volver</Link></Button>
        <h1 className="text-3xl font-heading mb-6">Condiciones de Uso</h1>
        <div className="prose prose-sm max-w-none space-y-4 text-muted-foreground">
          <h2 className="text-lg font-medium text-foreground">1. Objeto</h2>
          <p>Las presentes condiciones regulan el uso del servicio de reserva de citas online ofrecido a traves de esta pagina web.</p>

          <h2 className="text-lg font-medium text-foreground">2. Condiciones de reserva</h2>
          <ul className="list-disc pl-6">
            <li>El usuario debe proporcionar datos veridicos (nombre completo y telefono)</li>
            <li>Cada reserva es personal e intransferible</li>
            <li>El usuario debe presentarse puntualmente a la hora indicada</li>
          </ul>

          <h2 className="text-lg font-medium text-foreground">3. Politica de cancelacion</h2>
          <p>Las cancelaciones deben realizarse con un minimo de dias de antelacion segun lo configurado por el establecimiento. Para cancelaciones fuera de plazo, el usuario debera contactar directamente por telefono.</p>

          <h2 className="text-lg font-medium text-foreground">4. Uso indebido</h2>
          <p>El establecimiento se reserva el derecho de cancelar reservas realizadas de forma fraudulenta o repetitiva, asi como de bloquear a usuarios que hagan un uso indebido del sistema de reservas.</p>

          <h2 className="text-lg font-medium text-foreground">5. Modificaciones</h2>
          <p>El establecimiento se reserva el derecho de modificar estas condiciones en cualquier momento. Las modificaciones entraran en vigor desde su publicacion en la web.</p>

          <h2 className="text-lg font-medium text-foreground">6. Legislacion aplicable</h2>
          <p>Estas condiciones se rigen por la legislacion espanola. Para la resolucion de cualquier controversia seran competentes los juzgados y tribunales del domicilio del establecimiento.</p>
        </div>
      </div>
    </div>
  );
}
